import { createStyles } from "antd-style";

export const useCompanyKnowledgeStyles = createStyles(({ css, token }) => ({
  actionDeleteIcon: css`
    color: ${token.colorTextTertiary};
  `,
  actionIcon: css`
    color: ${token.colorPrimary};
  `,
  contentCard: css`
    background: ${token.colorBgContainer};
    box-shadow: ${token.boxShadowTertiary};
    min-height: 320px;
    padding: ${token.paddingLG}px 40px;
    width: 100%;
  `,
  deleteModal: css`
    .ant-modal-content {
      border-radius: ${token.borderRadiusLG}px;
      padding: 20px 24px;
    }

    .ant-modal-header {
      margin-bottom: ${token.marginXS}px;
    }

    .ant-modal-footer {
      margin-top: ${token.margin}px;
    }
  `,
  deleteModalBody: css`
    font-size: ${token.fontSize}px;
    line-height: 22px;
    margin-left: 36px;
  `,
  deleteModalCancelButton: css`
    && {
      border-color: #4e576a;
      border-radius: ${token.borderRadius}px;
      color: #4e576a;
      height: 32px;
      min-width: 76px;
      padding: 0 15px;
    }
  `,
  deleteModalDeleteButton: css`
    && {
      border-radius: ${token.borderRadiusLG}px;
      height: 32px;
      min-width: 75px;
      padding: 0 16px;
    }
  `,
  deleteModalIcon: css`
    color: ${token.colorWarning};
    font-size: 24px;
  `,
  deleteModalParagraph: css`
    && {
      font-size: ${token.fontSize}px;
      line-height: 22px;
      margin-bottom: 4px;
    }
  `,
  deleteModalTitle: css`
    && {
      font-size: ${token.fontSizeLG}px;
      font-weight: ${token.fontWeightStrong};
      line-height: 24px;
      margin-bottom: 0;
    }
  `,
  deleteImpactList: css`
    margin-bottom: 4px;
    margin-top: 0;
    padding-left: 22px;
  `,
  deleteModalError: css`
    && {
      font-size: ${token.fontSize}px;
      line-height: 22px;
      margin-bottom: 0;
      margin-top: ${token.marginXS}px;
    }
  `,
  fileButton: css`
    && {
      height: auto;
      padding: 0;
    }
  `,
  helperText: css`
    display: block;
    margin-bottom: 21px;
  `,
  modalHint: css`
    color: ${token.colorTextDescription};
  `,
  modalActions: css`
    margin-top: 20px;
    width: 100%;
  `,
  paginationSummary: css`
    white-space: nowrap;
  `,
  searchInput: css`
    max-width: 314px;
    width: 100%;
  `,
  searchRow: css`
    margin-bottom: 21px;
  `,
  switchFormItem: css`
    .ant-form-item-row {
      align-items: center;
      flex-wrap: nowrap;
    }

    .ant-form-item-label {
      flex: 1 1 auto !important;
      max-width: none;
      min-width: 0;
      text-align: left;
      white-space: normal;
    }

    .ant-form-item-label > label {
      height: auto;
      white-space: normal;
    }

    .ant-form-item-control {
      flex: 0 0 auto !important;
      max-width: none;
      width: auto;
    }
  `,
  table: css`
    margin-top: 0;
  `,
  uploadFormBlock: css`
    margin-bottom: ${token.marginXXS}px;
  `,
  uploadDragger: css`
    width: 100%;

    .ant-upload.ant-upload-drag {
      height: 170px;
      padding: 0;
      text-align: center;
    }

    .ant-upload.ant-upload-drag .ant-upload-btn {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      padding: ${token.padding}px;
    }

    .ant-upload-drag-container {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      width: 100%;
    }

    .ant-upload-drag-icon,
    .ant-upload-text,
    .ant-upload-hint {
      display: block;
      margin-bottom: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 0;
      text-align: center;
      width: 100%;
    }
  `,
  uploadIcon: css`
    color: ${token.colorPrimary};
    font-size: 48px;
  `,
  uploadIconWrapper: css`
    margin-bottom: ${token.margin}px !important;
  `,
  uploadPrimaryText: css`
    display: block;
    font-size: ${token.fontSizeLG}px;
    line-height: ${token.lineHeightLG};
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${token.marginXXS}px !important;
    text-align: center;
    width: 100%;
  `,
  uploadPrimaryTextLine: css`
    display: block;
  `,
}));
